import { EditTimeZoneCtrl } from '../controllers/EditTimeZoneCtrl';
import { Module } from '../Module';

Module.instance().directive('tbEditTimeZone', <any[]>[
    () => {
        return {
            restrict: 'E',
            replace: 'true',
            templateUrl: 'editTimeZone.html',
            scope: {
                controls: '=?',
                serverUser: '=',
                timeZoneId: '='
            },
            controller: EditTimeZoneCtrl
        };
    }
]);
